module.exports = __webpack_public_path__ + "img/40.d4ebb2e0.jpg";